module.exports = __webpack_public_path__ + "img/1.5ff6a28b.jpg";